var map = {
	"./16/bakery.svg": 6058,
	"./16/chicken.svg": 2915,
	"./16/chinese.svg": 3059,
	"./16/coffee.svg": 1670,
	"./16/convenience.svg": 8507,
	"./16/dessert.svg": 7800,
	"./16/education.svg": 1108,
	"./16/fastfood.svg": 8560,
	"./16/fusion.svg": 2718,
	"./16/internetcafe.svg": 5054,
	"./16/japanese.svg": 1155,
	"./16/korean.svg": 1878,
	"./16/laundry.svg": 745,
	"./16/leisure.svg": 279,
	"./16/life.svg": 436,
	"./16/pizza.svg": 2992,
	"./16/pub.svg": 4735,
	"./16/snack.svg": 4972,
	"./16/study.svg": 1633,
	"./16/western.svg": 1016,
	"./16/wholesaleretail.svg": 163,
	"./22/bakery.svg": 3589,
	"./22/chicken.svg": 3386,
	"./22/chinese.svg": 2866,
	"./22/coffee.svg": 5013,
	"./22/convenience.svg": 8066,
	"./22/dessert.svg": 2493,
	"./22/education.svg": 3321,
	"./22/fastfood.svg": 5296,
	"./22/fusion.svg": 2857,
	"./22/internetcafe.svg": 225,
	"./22/japanese.svg": 7524,
	"./22/korean.svg": 5165,
	"./22/laundry.svg": 2704,
	"./22/leisure.svg": 6122,
	"./22/life.svg": 9379,
	"./22/pizza.svg": 1549,
	"./22/pub.svg": 3862,
	"./22/snack.svg": 4925,
	"./22/study.svg": 9844,
	"./22/western.svg": 3949,
	"./22/wholesaleretail.svg": 382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 298;